export default __webpack_public_path__ + "static/media/kitchen5-afterE-1440w.5a55074f.webp";